module.exports = __webpack_public_path__ + "img/avens_0.98994b41.jpg";